<script>
export default {
   name: 'Cloud',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="189" height="56" fill="none" viewBox="0 0 189 56">
      <path
         fill="#178ece"
         d="M19.639 17.306c0 .854.092 1.546.252 2.054.184.508.413 1.062.734 1.662.115.184.16.369.16.53 0 .231-.137.462-.435.693l-1.445.969a1.1 1.1 0 0 1-.597.208c-.23 0-.459-.116-.688-.323a7 7 0 0 1-.826-1.085c-.23-.392-.459-.83-.71-1.362q-2.685 3.186-6.745 3.185c-1.928 0-3.465-.554-4.589-1.662s-1.697-2.584-1.697-4.43c0-1.962.688-3.555 2.087-4.755s3.258-1.8 5.62-1.8c.78 0 1.584.07 2.433.185s1.72.3 2.638.508v-1.685c0-1.754-.367-2.977-1.078-3.693-.735-.715-1.973-1.061-3.74-1.061-.803 0-1.629.092-2.477.3a18 18 0 0 0-2.478.784 7 7 0 0 1-.803.3 1.4 1.4 0 0 1-.367.07c-.321 0-.482-.231-.482-.716v-1.13c0-.37.046-.647.16-.808.116-.162.322-.323.643-.485Q6.414 3.136 8.1 2.72c1.125-.3 2.318-.438 3.58-.438 2.73 0 4.725.623 6.01 1.87 1.262 1.246 1.904 3.138 1.904 5.677v7.477zm-9.314 3.508c.757 0 1.537-.139 2.363-.416s1.56-.784 2.18-1.477c.366-.438.642-.923.78-1.477a8.3 8.3 0 0 0 .229-2.007v-.97c-.666-.161-1.377-.3-2.11-.392a17 17 0 0 0-2.157-.138c-1.537 0-2.661.3-3.419.923-.757.623-1.124 1.5-1.124 2.654 0 1.084.276 1.892.85 2.446.55.577 1.353.854 2.408.854m18.421 2.492c-.413 0-.688-.069-.871-.23-.184-.139-.344-.462-.482-.9l-5.391-17.84c-.138-.462-.207-.762-.207-.923 0-.37.184-.577.55-.577h2.25c.435 0 .733.07.894.23.183.14.321.462.459.9l3.854 15.279L33.38 3.966c.115-.462.253-.762.436-.9.184-.139.505-.231.918-.231h1.835c.436 0 .734.07.918.23.183.14.344.462.436.9l3.624 15.463 3.97-15.462c.137-.462.297-.762.458-.9.183-.139.482-.231.895-.231h2.133c.367 0 .574.185.574.577 0 .115-.023.23-.046.37a3.3 3.3 0 0 1-.16.576l-5.53 17.84q-.206.692-.481.9c-.184.138-.482.23-.872.23h-1.973c-.436 0-.734-.069-.918-.23-.183-.162-.344-.462-.436-.924L35.607 7.29l-3.533 14.862c-.115.462-.253.762-.436.924-.184.161-.505.23-.918.23zm29.48.623c-1.194 0-2.387-.138-3.534-.415s-2.041-.577-2.638-.923c-.367-.208-.62-.439-.711-.646a1.6 1.6 0 0 1-.138-.646v-1.177c0-.485.184-.716.528-.716q.207 0 .413.07c.138.046.344.138.573.23.78.346 1.63.623 2.524.808.918.184 1.812.277 2.73.277 1.445 0 2.57-.254 3.35-.762s1.192-1.246 1.192-2.192c0-.646-.206-1.177-.62-1.616-.412-.438-1.192-.83-2.316-1.2l-3.327-1.038c-1.674-.531-2.913-1.316-3.67-2.354-.757-1.016-1.147-2.147-1.147-3.347q0-1.454.62-2.561a5.9 5.9 0 0 1 1.65-1.893c.69-.53 1.47-.923 2.387-1.2s1.88-.392 2.89-.392c.505 0 1.033.023 1.537.092.528.07 1.01.162 1.492.254.458.115.894.23 1.307.37q.62.207.964.415c.32.184.55.369.688.577q.207.276.206.761V5.79c0 .485-.183.738-.527.738-.184 0-.482-.092-.872-.277q-1.962-.9-4.405-.9c-1.307 0-2.34.208-3.05.647-.712.438-1.079 1.107-1.079 2.054 0 .646.23 1.2.688 1.638.459.439 1.308.877 2.524 1.27l3.257 1.038c1.652.53 2.845 1.27 3.556 2.216s1.055 2.03 1.055 3.23c0 .993-.206 1.893-.596 2.678a6.2 6.2 0 0 1-1.675 2.03c-.711.577-1.56.993-2.546 1.293-1.033.323-2.11.484-3.28.484"
      />
      <path
         fill="#e2bd4d"
         fill-rule="evenodd"
         d="M62.562 35.145c-7.548 5.608-18.514 8.585-27.942 8.585-13.214 0-25.12-4.915-34.113-13.085-.711-.646-.07-1.523.78-1.015 9.727 5.677 21.725 9.116 34.136 9.116 8.373 0 17.572-1.754 26.037-5.355 1.262-.576 2.34.831 1.102 1.754"
         clip-rule="evenodd"
      />
      <path
         fill="#e2bd4d"
         fill-rule="evenodd"
         d="M65.705 31.545c-.964-1.246-6.378-.6-8.832-.3-.735.092-.85-.554-.184-1.039 4.313-3.046 11.402-2.169 12.227-1.154.826 1.039-.229 8.17-4.267 11.586-.619.53-1.215.254-.94-.439.917-2.285 2.96-7.43 1.996-8.654"
         clip-rule="evenodd"
      />
      <path
         fill="url(#a)"
         d="M96.357 13.731h13.021L95.861 53.782a2.08 2.08 0 0 1-1.967 1.412H83.76a2.074 2.074 0 0 1-1.965-2.735L94.39 15.143a2.08 2.08 0 0 1 1.968-1.412"
      />
      <path
         fill="#178ece"
         d="M115.279 40.595h-20.65a.956.956 0 0 0-.652 1.654l13.268 12.385c.387.36.895.56 1.424.56h11.692z"
      />
      <path
         fill="#178ece"
         d="M96.356 13.732a2.06 2.06 0 0 0-1.972 1.44L81.81 52.424a2.07 2.07 0 0 0 1.954 2.77H94.16a2.22 2.22 0 0 0 1.705-1.45l2.508-7.39 8.956 8.354c.376.31.847.482 1.334.486h11.648l-5.109-14.6-14.893.004 9.115-26.867z"
      />
      <path
         fill="#8bc7e7"
         d="M112.988 15.142a2.072 2.072 0 0 0-1.964-1.41H96.512a2.07 2.07 0 0 1 1.964 1.41l12.594 37.317a2.074 2.074 0 0 1-1.964 2.736h14.513a2.073 2.073 0 0 0 1.964-2.736z"
      />
      <path
         fill="#edcbd6"
         d="m171.06 11.573 4.409-4.457.294-1.876c-8.034-7.384-20.806-6.546-28.048 1.747-2.012 2.303-3.504 5.175-4.3 8.14l1.579-.224 8.817-1.47.681-.703c3.922-4.354 10.554-4.94 15.083-1.236z"
      />
      <path
         fill="#8bc7e7"
         d="M181.75 14.997a20.1 20.1 0 0 0-5.987-9.757l-6.188 6.254a11.17 11.17 0 0 1 4.038 8.819v1.11c3.041 0 5.507 2.492 5.507 5.566a5.484 5.484 0 0 1-5.507 5.503h-11.03l-1.083 1.189v6.676l1.083 1.047h11.03c7.911.063 14.374-6.306 14.436-14.302.037-4.846-2.327-9.39-6.299-12.105"
      />
      <path
         fill="#d2ebe4"
         d="M151.568 41.404h11.015v-8.912h-11.015c-.784 0-1.544-.17-2.258-.5l-1.563.485-4.439 4.456-.387 1.516c2.49 1.9 5.528 2.969 8.647 2.955"
      />
      <path
         fill="#e2bd4d"
         d="M151.568 12.495c-7.911.048-14.286 6.568-14.239 14.564a14.53 14.53 0 0 0 5.592 11.39l6.389-6.457c-2.772-1.266-4.004-4.563-2.751-7.364s4.514-4.047 7.286-2.781a5.54 5.54 0 0 1 2.751 2.78l6.389-6.456a14.26 14.26 0 0 0-11.417-5.676"
      />
      <defs>
         <linearGradient
            id="a"
            x1="101.102"
            x2="87.579"
            y1="16.804"
            y2="56.754"
            gradientUnits="userSpaceOnUse"
         >
            <stop stop-color="#178ece" />
            <stop offset="1" stop-color="#8bc7e7" />
         </linearGradient>
      </defs>
   </svg>
</template>

<style scoped lang="scss"></style>
